import { useTypedParams } from '@sorare/routing';
import { parsePlayerPoolTierSlug } from '@sorare/core/src/lib/playerPoolTiers';
import { isRarityStr } from '@sorare/core/src/lib/so5';

import { RewardsEssenceTierRarityPage } from '#src/pages/rewards/RewardsEssenceTierRarityPage/index.tsx';

import type { PageParams } from './__generated__/routeParams.ts';

const RewardsEssencePage = () => {
  const { tier, rarity } = useTypedParams<PageParams>();
  const poolTier = parsePlayerPoolTierSlug(tier);

  if (!poolTier || !isRarityStr(rarity)) {
    return null;
  }

  return <RewardsEssenceTierRarityPage tier={poolTier} rarity={rarity} />;
};

export default RewardsEssencePage;
